import { createStructuredSelector } from "reselect";
import {
    DISPENSING_UNIT_LIST,
    DISPENSING_UNIT_LIST_SUCCESS,
    DISPENSING_UNIT_LIST_ERROR,
    DISPENSING_UNIT_PAGE_SET,
    DISPENSING_UNIT_HEADER,
    DISPENSING_UNIT_SEARCH_SET,
    DISPENSING_UNIT_SEARCH_CHANGE,
    DISPENSING_UNIT_ADD_SET,
    DISPENSING_UNIT_ADD_MODAL_SET,
    DISPENSING_UNIT_ADD,
    DISPENSING_UNIT_ADD_SUCCESS,
    DISPENSING_UNIT_ADD_ERROR,
    DISPENSING_UNIT_ADD_CHANGE,
    DISPENSING_UNIT_EDIT_SET,
    DISPENSING_UNIT_EDIT_CHANGE,
    DISPENSING_UNIT_EDIT_MODAL_SET,
    DISPENSING_UNIT_DETAIL,
    DISPENSING_UNIT_DETAIL_SUCCESS,
    DISPENSING_UNIT_DETAIL_ERROR,
    DISPENSING_UNIT_UPDATE,
    DISPENSING_UNIT_UPDATE_SUCCESS,
    DISPENSING_UNIT_UPDATE_ERROR
} from "../actions";

export const NAME = 'dispensingUnit';

export const DispensingUnitList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: DISPENSING_UNIT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DispensingUnitListSuccess = (data) => ({
    type: DISPENSING_UNIT_LIST_SUCCESS,
    payload: data
});

export const DispensingUnitListError = (error) => ({
    type: DISPENSING_UNIT_LIST_ERROR,
    payload: error
});

export const DispensingUnitPageSet = (data) => ({
    type: DISPENSING_UNIT_PAGE_SET,
    payload: data
});

export const DispensingUnitHeader = (data) => ({
    type: DISPENSING_UNIT_HEADER,
    payload: data
})

export const DispensingUnitSearchSet = (data) => ({
    type: DISPENSING_UNIT_SEARCH_SET,
    payload: data
});

export const DispensingUnitSearchChangeSet = (data) => ({
    type: DISPENSING_UNIT_SEARCH_CHANGE,
    payload: data
});


export const DispensingUnitAddChangeSet = (data) => ({
    type: DISPENSING_UNIT_ADD_CHANGE,
    payload: data
});

export const DispensingUnitAddSet = (data) => ({
    type: DISPENSING_UNIT_ADD_SET,
    payload: data
});

export const DispensingUnitAddModalSet = (data) => ({
    type: DISPENSING_UNIT_ADD_MODAL_SET,
    payload: data
});

export const DispensingUnitAdd = (data) => ({
    type: DISPENSING_UNIT_ADD,
    payload: data
});

export const DispensingUnitAddSuccess = (message) => ({
    type: DISPENSING_UNIT_ADD_SUCCESS,
    payload: message
});

export const DispensingUnitAddError = (error) => ({
    type: DISPENSING_UNIT_ADD_ERROR,
    payload: error
});

export const DispensingUnitEditSet = (data) => ({
    type: DISPENSING_UNIT_EDIT_SET,
    payload: data
});

export const DispensingUnitEditChangeSet = (data) => ({
    type: DISPENSING_UNIT_EDIT_CHANGE,
    payload: data
});

export const DispensingUnitEditModalSet = (data) => ({
    type: DISPENSING_UNIT_EDIT_MODAL_SET,
    payload: data
});

export const DispensingUnitEditTabSet = (data) => ({
    type: DISPENSING_UNIT_EDIT_TAB_SET,
    payload: data
});

export const DispensingUnitDetail = (data) => ({
    type: DISPENSING_UNIT_DETAIL,
    payload: data
});

export const DispensingUnitDetailSuccess = (data) => ({
    type: DISPENSING_UNIT_DETAIL_SUCCESS,
    payload: data
});

export const DispensingUnitDetailError = (error) => ({
    type: DISPENSING_UNIT_DETAIL_ERROR,
    payload: error
});

export const DispensingUnitUpdate = (data) => ({
    type: DISPENSING_UNIT_UPDATE,
    payload: data
});

export const DispensingUnitUpdateSuccess = (message) => ({
    type: DISPENSING_UNIT_UPDATE_SUCCESS,
    payload: message.message
});

export const DispensingUnitUpdateError = (error) => ({
    type: DISPENSING_UNIT_UPDATE_ERROR,
    payload: error
});



const dispensingUnit = (state) => state[NAME];

export const DispensingUnitSelector = createStructuredSelector({
    dispensingUnit
})
